import styles from './invictustest.module.css'

const InvictusTestCriteria = () => {
    return (
        <div>
            <div className={`container ${styles.bg_mweb_invictus}`}>
                {/*-------- Invictus Test Criteria*/}
                <div className={`${styles.mn_criteria}`}>
                    <div className={`${styles.test_detail_wrapper}`}>
                        <h2>Test details</h2>
                        <div className={`${styles.test_dt_three}`}>
                            {/* box1 */}
                            <div className={`${styles.test_dt_box}`}>
                                <div>
                                    <img
                                        src="https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/online-icon1.svg"
                                        alt=""
                                    />
                                </div>
                                <div>
                                    <h6>Offline mode</h6>
                                    <p>
                                        Focused exam experience, the traditional way
                                    </p>
                                </div>
                            </div>
                            <div className={`${styles.br_rt}`}></div>
                            {/* box1 */}
                            {/* box2 */}
                            <div className={`${styles.test_dt_box}`}>
                                <div>
                                    <img
                                        src="https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/time-icon2.svg"
                                        alt=""
                                    />
                                </div>
                                <div>
                                    <h6>
                                    Your Exam, Your Time
                                    </h6>
                                    <p>Select a date that fits.</p>
                                </div>
                            </div>
                            <div className={`${styles.br_rt}`}></div>
                            {/* box2 */}
                            {/* box3 */}
                            <div className={`${styles.test_dt_box}`}>
                                <div>
                                    <img
                                        src="https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/watch-icon3.svg"
                                        alt=""
                                    />
                                </div>
                                <div>
                                    <h6>3 hours duration</h6>
                                    <p>Time to showcase your knowledge</p>
                                </div>
                            </div>
                            {/* box3 */}
                        </div>
                    </div>
                </div>
                {/*------- Invictus Criteria*/}
            </div>
        </div>
    )
}

export default InvictusTestCriteria
